/**
 * brainGeometryLoader — lazily fetch the brain geometry (node/edge table) once
 * and memoize it. The ~28KB asset stays off the chat critical path; it's loaded
 * the first time a brain card animates or the /discovery brain renders.
 *
 * @module components/brain/brainGeometryLoader
 */

let _geometryPromise = null;

/**
 * @returns {Promise<{world:object, clusters:object, cats:object, nodes:Array, edges:Array}>}
 */
export function loadBrainGeometry() {
  if (!_geometryPromise) {
    _geometryPromise = import("./brainGeometry.json")
      .then((m) => m.default || m)
      .catch((err) => {
        _geometryPromise = null; // allow retry on next call
        throw err;
      });
  }
  return _geometryPromise;
}

export default loadBrainGeometry;
